// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__2RAxN","inputLabel":"styles_inputLabel__2dKLn"};